import { render, staticRenderFns } from "./H5Detail.vue?vue&type=template&id=71b6f980&scoped=true"
import script from "./H5Detail.vue?vue&type=script&lang=js"
export * from "./H5Detail.vue?vue&type=script&lang=js"
import style0 from "./H5Detail.vue?vue&type=style&index=0&id=71b6f980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6f980",
  null
  
)

export default component.exports